import { Map, Package, ClipboardList } from "lucide-react";

const Stats = () => {
    const stats = [
        {
            value: "25+",
            label: "States",
            icon: <Map size={48} strokeWidth={1} className="text-primary mb-4" />
        },
        {
            value: "100,000+",
            label: "MT Steel Delivered Annually",
            icon: <Package size={48} strokeWidth={1} className="text-primary mb-4" />
        },
        {
            value: "1000+",
            label: "Projects",
            icon: <ClipboardList size={48} strokeWidth={1} className="text-primary mb-4" />
        }
    ];

    return (
        <section className="py-20 bg-slate-50 border-y border-slate-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center divide-y md:divide-y-0 md:divide-x divide-slate-200">
                    {stats.map((stat, idx) => (
                        <div key={idx} className="flex flex-col items-center justify-center p-6">
                            {stat.icon}
                            <h4 className="text-4xl md:text-5xl font-bold font-heading text-primary mb-2">
                                {stat.value}
                            </h4>
                            <p className="text-slate-500 font-medium text-lg uppercase tracking-wide">
                                {stat.label}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Stats;
